import { InsertDivider } from './insert-divider.js';
import { EditDivider } from './edit-divider.js';


export function Divider (pEditor)
{
  this.inserter = new InsertDivider(pEditor, this);
  this.editor = new EditDivider(pEditor, this);

}